import { EnumDocumentType } from '@getaccept/lib-shared/src/enums/DocumentType';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { EnumAppMode } from '@getaccept/lib-shared/src/enums/AppMode';
import type { CreateDocumentOptionOld } from '../types/old-create-document-option';
import type { CreateDocumentOption } from '../types/create-document-option';

export class CreateDocumentConstants {
  private static translatedCreateDocumentSalesDescription(): string {
    return t('create-document-sales-description').toString();
  }
  private static defaultDocumentTypes = (): CreateDocumentOption[] => [
    {
      title: t('contract'),
      type: EnumDocumentType.Hr,
      description: t('create-document-contract-description').toString(),
      icon: `document-${EnumDocumentType.Hr}`,
      displayMode: [EnumAppMode.Business],
    },
    {
      title: t('hr'),
      type: EnumDocumentType.Hr,
      description: t('create-document-hr-description').toString(),
      icon: `document-${EnumDocumentType.Hr}`,
      displayMode: [EnumAppMode.Sales],
    },
    {
      title: t('other'),
      type: EnumDocumentType.Other,
      description: t('create-document-other-description').toString(),
      icon: `document-${EnumDocumentType.Other}`,
      displayMode: [EnumAppMode.Sales, EnumAppMode.Business],
    },
  ];

  static oldDocumentTypes: CreateDocumentOptionOld[] = [
    {
      tooltipContent: 'sales-description',
      selectedType: EnumDocumentType.Sales,
      iconClasses: 'icon-sales icon',
      textValue: 'Sales',
      displayMode: [EnumAppMode.Sales],
    },
    {
      tooltipContent: 'contract-description',
      selectedType: EnumDocumentType.Hr,
      iconClasses: 'icon-sign icon',
      textValue: 'Contract',
      displayMode: [EnumAppMode.Business],
    },
    {
      tooltipContent: 'presentation-description',
      selectedType: EnumDocumentType.Introduction,
      iconClasses: 'icon-introduction icon',
      textValue: 'Presentation',
      displayMode: [EnumAppMode.Sales, EnumAppMode.Business],
    },
    {
      tooltipContent: 'hr-description',
      selectedType: EnumDocumentType.Hr,
      iconClasses: 'icon-hr icon',
      textValue: 'HR',
      displayMode: [EnumAppMode.Sales],
    },
    {
      tooltipContent: 'other-description',
      selectedType: EnumDocumentType.Other,
      iconClasses: 'icon-document icon',
      textValue: 'Other',
      displayMode: [EnumAppMode.Sales, EnumAppMode.Business],
    },
  ];

  static documentTypes: () => CreateDocumentOption[] = () => [
    {
      title: t('digital-sales-room').toString(),
      type: EnumDocumentType.Introduction,
      description: t('create-document-dsr-description').toString(),
      icon: `document-${EnumDocumentType.DSR}`,
      displayMode: [EnumAppMode.Sales, EnumAppMode.Business],
    },
    {
      title: t('sales'),
      type: EnumDocumentType.Sales,
      description: this.translatedCreateDocumentSalesDescription(),
      icon: `document-${EnumDocumentType.Sales}`,
      displayMode: [EnumAppMode.Sales],
    },
    ...this.defaultDocumentTypes(),
  ];
}
